import { put, call, fork, takeEvery, all } from 'redux-saga/effects';
import {

  addFileUploadSuccess,
  addCustFileUploadSuccess,
  addFileUploadFailure,
  addCustFileUploadFailure,
  addPolicyFileUploadSuccess,
  addPolicyFileUploadFailure,
  getLeadsBulkUploadsSuccess,
  getLeadsBulkUploadsFailed,
  revertBulkUploadSuccess,
  revertBulkUploadFailed,
  getCustBulkUploadSuccess,
  getCustBulkUploadFailed,
  getPolicyBulkUploadSuccess,
  getPolicyBulkUploadFailed,
  getLifeBulkPoliciesSuccess,
  getLifeBulkPoliciesFailed,
  addMutualFundFileUploadSuccess,
  addMutualFundFileUploadFailure,
  getMutualFundBulkUploadsSuccess,
  getMutualFundBulkUploadsFailed,
  revertMutualFundBulkUploadSuccess,
  revertMutualFundBulkUploadFailed,
} from './action';
import {
  ADD_FILEUPLOAD_START,
  ADD_CUSTFILEUPLOAD_START,
  ADD_POLICYFILEUPLOAD_START,
  GET_LEADS_BULKUPLOADS,
  REVERT_BULK_UPLOAD,
  GET_CUST_BULKUPLOAD,
  GET_POLICY_BULKUPLOAD,
  GET_LIFE_BULKPOLICIES,
  ADD_MUTUALFUNDFILEUPLOAD_START,
  GET_MUTUALFUND_BULKUPLOADS,
  REVERT_MUTUALFUND_BULK_UPLOAD,
} from "./actiontypes";

import { uploadFileAPI, CustuploadFileAPI, PolicyuploadFileAPI, getLeadsBulkUploadsAPI, revertBulkUploadAPI, getCustBulkUploadsAPI, getPolicyBulkUploadsAPI, getLifeBulkPoliciesAPI, mutualFundBulkuploadAPI, revertMutualFundBulkUploadAPI, getMutualFundBulkUploadsAPI } from './api';


function* handleFileUploadAsync(action) {
  try {
    const response = yield call(uploadFileAPI, action.payload);
    if (response.status === 200 || 202) {
      yield put(addFileUploadSuccess(response));
      //  console.log(response)
    }
  } catch (error) {
    yield put(addFileUploadFailure(error.message));
  }
}


function* handleFileUpload() {
  yield takeEvery(ADD_FILEUPLOAD_START, handleFileUploadAsync)
}

function* handleCustFileUploadAsync(action) {
  try {
    const response = yield call(CustuploadFileAPI, action.payload);
    if (response.status === 200 || 202) {
      yield put(addCustFileUploadSuccess(response));
      //  console.log(response)
    }
  } catch (error) {
    yield put(addCustFileUploadFailure(error.message));
  }
}

function* handleCustFileUpload() {
  yield takeEvery(ADD_CUSTFILEUPLOAD_START, handleCustFileUploadAsync)
}


function* handlePolicyFileUploadAsync(action) {
  try {
    const response = yield call(PolicyuploadFileAPI, action.payload);
    if (response.status === 200 || 202) {
      yield put(addPolicyFileUploadSuccess(response));
      //  console.log(response)
    }
  } catch (error) {
    yield put(addPolicyFileUploadFailure(error.message));
  }
}

function* handlepolicyFileUpload() {
  yield takeEvery(ADD_POLICYFILEUPLOAD_START, handlePolicyFileUploadAsync)
}


function* getLeadsBulkUploadAsync(action) {
  try {
    const response = yield call(getLeadsBulkUploadsAPI, action.payload);
    if (response.status === 200 || 202) {
      yield put(getLeadsBulkUploadsSuccess(response.data.data || []));
      //  console.log(response)
    }
  } catch (error) {
    yield put(getLeadsBulkUploadsFailed(error.response.message));
  }
}

function* getLeadsBulkUpload() {
  yield takeEvery(GET_LEADS_BULKUPLOADS, getLeadsBulkUploadAsync)
}



function* getCustBulkUploadAsync(action) {
  try {
    const response = yield call(getCustBulkUploadsAPI, action.payload);
    if (response.status === 200 || 202) {
      yield put(getCustBulkUploadSuccess(response.data.data || []));
      //  console.log(response)
    }
  } catch (error) {
    yield put(getCustBulkUploadFailed(error.response.message));
  }
}

function* getCustBulkUpload() {
  yield takeEvery(GET_CUST_BULKUPLOAD, getCustBulkUploadAsync)
}


function* getPolicyBulkUploadAsync(action) {
  try {
    const response = yield call(getPolicyBulkUploadsAPI, action.payload);
    if (response.status === 200 || 202) {
      yield put(getPolicyBulkUploadSuccess(response.data.data || []));
      //  console.log(response)
    }
  } catch (error) {
    yield put(getPolicyBulkUploadFailed(error.response.message));
  }
}

function* getPolicyBulkUpload() {
  yield takeEvery(GET_POLICY_BULKUPLOAD, getPolicyBulkUploadAsync)
}


function* revertBulkUploadAsync(action) {
  try {
    const response = yield call(revertBulkUploadAPI, action.payload);
    if (response.status === 200 || 202) {
      yield put(revertBulkUploadSuccess(response.data.massage || "Reverted Successfully"));
      //  console.log(response)
    }
  } catch (error) {
    yield put(revertBulkUploadFailed(error.response.message));
  }
}

function* revertBulkUpload() {
  yield takeEvery(REVERT_BULK_UPLOAD, revertBulkUploadAsync)
}





function* getLifeBulkPolicyAsync(action) {
  try {
    const response = yield call(getLifeBulkPoliciesAPI, action.payload);
    if (response.status === 200 || 202) {
      yield put(getLifeBulkPoliciesSuccess(response?.data?.data || []));
      //  console.log(response)
    }
  } catch (error) {
    yield put(getLifeBulkPoliciesFailed(error.response.message));
  }
}

function* getLifeBulkPolicy() {
  yield takeEvery(GET_LIFE_BULKPOLICIES, getLifeBulkPolicyAsync)
}

function* handleMutualFundFileUploadAsync(action) {
  try {
    const response = yield call(mutualFundBulkuploadAPI, action.payload);
    if (response.status === 200 || response.status === 202) {
      yield put(addMutualFundFileUploadSuccess(response));
    }
  } catch (error) {
    yield put(addMutualFundFileUploadFailure(error.message));
  }
}

function* handleMutualFundFileUpload() {
  yield takeEvery(ADD_MUTUALFUNDFILEUPLOAD_START, handleMutualFundFileUploadAsync);
}


// 🔥 FIXED: Get Mutual Fund Bulk Uploads
function* getMutualFundBulkUploadAsync(action) {
  try {
    const response = yield call(getMutualFundBulkUploadsAPI, action.payload);
    if (response.status === 200 || response.status === 202) {
      yield put(getMutualFundBulkUploadsSuccess(response.data.data || []));
    }
  } catch (error) {
    yield put(getMutualFundBulkUploadsFailed(error.response?.message));
  }
}

function* getMutualFundBulkUpload() {
  yield takeEvery(GET_MUTUALFUND_BULKUPLOADS, getMutualFundBulkUploadAsync);
}


// 🔥 FIXED: Revert Mutual Fund Bulk Upload
function* revertMutualFundBulkUploadAsync(action) {
  try {
    const response = yield call(revertMutualFundBulkUploadAPI, action.payload);
    if (response.status === 200 || response.status === 202) {
      yield put(
        revertMutualFundBulkUploadSuccess(
          response.data.message || "Reverted Successfully"
        )
      );
    }
  } catch (error) {
    yield put(revertMutualFundBulkUploadFailed(error.response?.message));
  }
}

function* revertMutualFundBulkUpload() {
  yield takeEvery(REVERT_MUTUALFUND_BULK_UPLOAD, revertMutualFundBulkUploadAsync);
}


function* FileUpload() {

  yield all([
    fork(handleFileUpload),
    fork(handleCustFileUpload),
    fork(handlepolicyFileUpload),
    fork(getLeadsBulkUpload),
    fork(getCustBulkUpload),
    fork(revertBulkUpload),
    fork(getPolicyBulkUpload),
    fork(getLifeBulkPolicy),
    fork(handleMutualFundFileUpload),
    fork(getMutualFundBulkUpload),
    fork(revertMutualFundBulkUpload),
  ])
}

export default FileUpload;
